import { render } from "./OzonPayButton.vue?vue&type=template&id=ba6596be&ts=true"
import script from "./OzonPayButton.vue?vue&type=script&lang=ts"
export * from "./OzonPayButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__